export { BaseModal } from "./BaseModal";
